<h3 mat-dialog-title>Select Your Bank</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content>
    <div class="plaid-search-container mx-auto text-center">
        <img class="img img-fluid mb-4" alt="bank icon"
             src="/assets/images/payhoa/dashboardEmpty/bank.svg"/>
        <div class="card">
            <div class="card-body">
                <input (keyup.enter)="cancelEvent($event);"
                       [formControl]="institutionSearchControl"
                       class="form-control w-100"
                       name="search"
                       placeholder="Search by bank name..." type="text"/>
            </div>
            <div class="list-group list-group-flush" *ngIf="institutions.length">
                <div (click)="selectInstitution(inst);"
                     *ngFor="let inst of institutions"
                     [attr.data-institution-id]="inst.institutionId"
                     class="list-group-item">
                    <div class="d-flex w-100 justify-content-between">
                            <span>
                                {{inst.name}}
                            </span>
                        <i class="fa fa-angle-right mr-2 fa-2x ml-auto"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="preferencesLoaded && data.product === 'auth'">
    <ng-container *ngIf="manualAddEnabled">
        <span>Can't find your bank?</span>
        <button [attr.aria-label]="'Add account manually'" class="btn btn-outline-primary" (click)="selectInstitution(null);">
            Add it with account
            and routing numbers &raquo;
        </button>
    </ng-container>
    <p *ngIf=" !manualAddEnabled" class="text-center mt-3 mb-1">
        Can't find your bank? Please contact PayHOA to enable manual account linking.
    </p>
</mat-dialog-actions>
